import React from 'react';
import { ShapePicker } from './ShapePicker';
import { ColorPicker } from './ColorPicker';

interface ShapeWithColorOverrideProps {
  label: string;
  tooltip: string;
  type: 'module' | 'corner' | 'eye';
  options: string[];
  shapeValue: string;
  onShapeChange: (v: string) => void;
  colorValue: string | null;
  onColorChange: (c: string | null) => void;
  overrideLabel: string;
  defaultOverrideColor: string;
}

export const ShapeWithColorOverride: React.FC<ShapeWithColorOverrideProps> = ({
  label, tooltip, type, options, shapeValue, onShapeChange, colorValue, onColorChange, overrideLabel, defaultOverrideColor
}) => {
  const handleToggle = (checked: boolean) => {
    onColorChange(checked ? defaultOverrideColor : null);
  };

  return (
    <div className="design-section">
      <ShapePicker 
        label={label}
        tooltip={tooltip}
        type={type}
        options={options}
        value={shapeValue}
        onChange={onShapeChange}
      />
      <div className="checkbox-group nested-override">
        <input 
          type="checkbox" 
          id={`override-${type}`} 
          checked={colorValue !== null} 
          onChange={e => { handleToggle(e.target.checked); }} 
        />
        <label htmlFor={`override-${type}`}>{overrideLabel}</label>
      </div>
      {colorValue !== null && (
        <ColorPicker color={colorValue} onChange={c => { onColorChange(c); }} />
      )}
    </div>
  );
};
